(function() {
  'use strict';

  angular
    .module('admin.users.details.collections', [
      'admin.users.details.collections.service',
      'admin.users.details.collections.sets',
      'admin.users.details.collections.sets.prints'
    ])
    .controller('CollectionsAdminCtrl', CollectionsAdminCtrl);

  /** @ngInject */
  function CollectionsAdminCtrl($stateParams, CollectionsAdminService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.username = $stateParams.username;
    vm.channels = [];

    load();

    function load(){
      CollectionsAdminService.listChannels($stateParams.parentId).then(success);

      function success(result){
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].username = vm.username;
        }
        vm.items = result.results;
      }
    }
  }

})();
